/** 画像の自然サイズ（px） */
export type NaturalSize = { w: number; h: number }

/**
 * w × h の矩形を deg 度回したときの外接矩形。
 * インラインの容器比・scale とライトボックスの wrapper はどちらもこの 1 つの規則で決める。
 * 90° の倍数で cos/sin の丸め誤差が混ざらないよう 1/1000 px に丸める。
 */
export const getRotatedBox = (
  size: NaturalSize,
  deg: number
): { bw: number; bh: number } => {
  const rad = (deg * Math.PI) / 180
  const cos = Math.abs(Math.cos(rad))
  const sin = Math.abs(Math.sin(rad))
  const round = (value: number) => Math.round(value * 1000) / 1000
  return {
    bw: round(size.w * cos + size.h * sin),
    bh: round(size.w * sin + size.h * cos),
  }
}
